import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { Text } from 'office-ui-fabric-react/lib/Text';
import styles from './SavingIndicator.style';

const SavingIndicator = ({ className: classNameProp, ...other }) => (
  <div className={clsx(styles.root, classNameProp)} {...other}>
    <Spinner
      data-testid="pause-transaction-spinner"
      size={SpinnerSize.small}
      className={styles.loadingSpinner}
    />
    <Text className={styles.savingText}>Saving...</Text>
  </div>
);

SavingIndicator.propTypes = {
  className: PropTypes.string,
};

SavingIndicator.defaultProps = {
  className: '',
};

export default SavingIndicator;
